'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectModelPropType = exports.OptionPropType = exports.ComponentPropType = exports.NumOrStringPropType = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NumOrStringPropType = exports.NumOrStringPropType = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
var ComponentPropType = exports.ComponentPropType = _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]);
var OptionPropType = exports.OptionPropType = _propTypes2.default.shape({
  value: NumOrStringPropType,
  label: NumOrStringPropType
});

var SelectModelPropType = exports.SelectModelPropType = _propTypes2.default.shape({
  state: _propTypes2.default.shape({
    optionsAll: _propTypes2.default.arrayOf(OptionPropType),
    multi: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,

    options: _propTypes2.default.arrayOf(OptionPropType),
    value: _propTypes2.default.string,
    selected: _propTypes2.default.oneOfType([OptionPropType, _propTypes2.default.arrayOf(OptionPropType)]),
    index: NumOrStringPropType,
    isOpen: _propTypes2.default.bool
  }),

  actions: _propTypes2.default.shape({
    setValue: _propTypes2.default.func,
    clearValue: _propTypes2.default.func,

    pushIndexedToSelected: _propTypes2.default.func,
    pushSelected: _propTypes2.default.func,
    popSelected: _propTypes2.default.func,
    clearSelected: _propTypes2.default.func,

    openMenu: _propTypes2.default.func,
    closeMenu: _propTypes2.default.func,
    setIndex: _propTypes2.default.func,
    incrementIndex: _propTypes2.default.func,
    decrementIndex: _propTypes2.default.func
  }),

  helpers: _propTypes2.default.shape({
    pluckLabel: _propTypes2.default.func,
    pluckValue: _propTypes2.default.func
  })
});